<template>
  <form class="form-invoice-payment" v-on:submit.prevent="onSubmit">
    <the-select
      option-title-key="name"
      option-value-key="id"
      v-bind:disabled="isCashboxSelectDisabled"
      v-bind:optional="false"
      v-bind:options="cashboxList"
      v-bind:value="selectedCashboxId"
      v-on:input="onSelectCashbox"
    />
    <div class="form-invoice-payment__head">
      <span>Долг:</span>
      <the-rub
        currency="тнг"
        v-bind:kop="debt"
        v-bind:show-kop="$options.SHOW_KOP_AUTO"
      />
      <span>Внести:</span>
      <the-rub
        v-if="isMixedPayment"
        currency="тнг"
        v-bind:kop="mixedPaymentAmount"
        v-bind:show-kop="$options.SHOW_KOP_AUTO"
      />
      <the-rub
        v-else
        currency="тнг"
        v-bind:kop="amountToPaid"
        v-bind:show-kop="$options.SHOW_KOP_AUTO"
      />
    </div>
    <div class="form-invoice-payment__payment-type">
      <p class="form-invoice-payment__payment-type__title">Способ оплаты:</p>
      <div class="form-invoice-payment__switch">
        <v-switch
          v-model="isMixedPayment"
          class="form-invoice-payment__switch"
          hide-details
          inset
          title="Смешанная оплата"
          v-on:change="onInputIsMixedPay"
        />
        <span>Смешанная оплата</span>
      </div>
    </div>
    <div class="form-invoice-payment__inputs">
      <div v-if="isMixedPayment" class="form-invoice-payment__mixed">
        <div class="form-invoice-payment__group">
          <label class="form-invoice-payment__label" for="cash">Наличными:</label>
          <price-input
            v-model="cash"
            class="form-invoice-payment__mixed__input"
            inputmode="numeric"
            name="cash"
            type="text"
            v-bind:with-currency="false"
          />
          <span>тнг</span>
        </div>
        <div class="form-invoice-payment__group">
          <label
            class="form-invoice-payment__label"
            for="electronically"
          >
            Картой:
          </label>
          <price-input
            v-model="cashless"
            class="form-invoice-payment__mixed__input"
            inputmode="numeric"
            name="electronically"
            type="text"
            v-bind:with-currency="false"
          />
          <span>тнг</span>
        </div>
        <div v-if="availableAdvance" class="form-invoice-payment__group">
          <label
            class="form-invoice-payment__label"
            for="advance"
          >
            С аванса (
            <the-rub
              v-bind:kop="availableAdvance"
              v-bind:show-kop="$options.SHOW_KOP_AUTO"
            />
            ):
          </label>
          <price-input
            v-model="advance"
            class="form-invoice-payment__mixed__input"
            inputmode="numeric"
            name="advance"
            type="text"
            v-bind:max="availableAdvance"
            v-bind:with-currency="false"
          />
          <span>тнг</span>
        </div>
        <template v-if="isAvailableBonusCard">
          <div class="form-invoice-payment__group">
            <label
              class="form-invoice-payment__label"
              for="advance"
            >
              С Бонусной карты
              <br>
              ( <the-bonus v-bind:bonuses="patientLoyaltyCard.amount" v-bind:postfix="''" />):
            </label>
            <bonus-input
              v-model="bonuses"
              inputmode="numeric"
              v-bind:max="availableBonuses"
            />
          </div>
        </template>

      </div>
      <div v-else class="form-invoice-payment__payment-types">
        <label class="form-invoice-payment__radio">
          <input
            v-model="selectedPaymentType"
            name="payment-type"
            type="radio"
            v-bind:value="$options.paymentByCash"
          />
          <span>Наличными</span>
        </label>
        <label class="form-invoice-payment__radio">
          <input
            v-model="selectedPaymentType"
            name="payment-type"
            type="radio"
            v-bind:value="$options.paymentByCashless"
          />
          <span>Картой</span>
        </label>
        <label
          v-if="isCanFullyPayByBonuses"
          class="form-invoice-payment__radio">
          <input
            v-model="selectedPaymentType"
            name="payment-type"
            type="radio"
            v-bind:value="$options.paymentByBonusCard"
          />
          <span>Бонусной картой ({{ patientLoyaltyCard.amount }})</span>
        </label>
        <template v-if="isOnlineCheckCashbox">
          <div class="form-invoice-payment__qr-code">
            <label class="form-invoice-payment__radio">
              <input
                v-model="selectedPaymentType"
                name="payment-type"
                type="radio"
                v-bind:value="$options.paymentByQRCode"
              />
              <span>QR-код</span>
            </label>
            <p v-if="isSelectedPaymentByQRCode" class="form-invoice-payment__warning">
              Сначала получите перевод денег от клиента, потом проведите оплату в МИС
            </p>
          </div>
        </template>
        <label v-if="!isAdvancePaymentDisabled" class="form-invoice-payment__radio">
          <input
            v-model="selectedPaymentType"
            name="payment-type"
            type="radio"
            v-bind:value="$options.paymentByAdvance"
          />
          <span>
            С аванса (<the-rub
              v-bind:kop="availableAdvance"
              v-bind:show-kop="$options.SHOW_KOP_AUTO"
            />)
          </span>
        </label>
      </div>
    </div>
    <div class="form-invoice-payment__controls">
      <button
        class="form-invoice-payment__buttons__button-cancel"
        type="button"
        v-on:click="dispatchCancel"
      >
        Отмена
      </button>
      <button v-if="isAwaitShiftOpened" type="button">shift status</button>
      <modal-dialog
        v-model="shownConfirmDialog"
        max-width="400px"
        persistent
        title="Подтвердите оплату"
        width="90%"
        with-cross>
        <template v-slot:trigger="{ listenerObject }">
          <button
            class="form-invoice-payment__buttons__button-submit"
            type="button"
            v-bind:disabled="isDisabledPaymentButton"
            v-on="listenerObject"
          >
            Оплатить
          </button>
        </template>
        <div class="form-invoice-payment__confirm-dialog">
          Оплата на сумму: <b>
            <the-rub
              currency="тнг"
              v-bind:kop="finalAmount"
              v-bind:show-kop="$options.SHOW_KOP_AUTO"
            />
          </b>
          <br>
          <div class="form-invoice-payment__confirm-dialog__buttons">
            <button
              class="form-invoice-payment__confirm-dialog__button-cancel"
              type="button"
              v-on:click="shownConfirmDialog = false"
            >
              Отмена
            </button>
            <button
              class="form-invoice-payment__confirm-dialog__button-submit"
              type="button"
              v-bind:disabled="isAwaitRequest"
              v-on:click="onSubmit"
            >
              Подтвердить
            </button>
          </div>
        </div>
      </modal-dialog>
    </div>
  </form>
</template>

<script>
import { PaymentType, PayRequest } from '@/storage/gateways/InvoiceGateway';
import PriceInput from '@/components/PriceInput.vue';
import TheRub, { SHOW_KOP_AUTO } from '@/components/TheRub.vue';
import TheSelect from '@/components/TheSelect.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import metricMixin from '@/mixins/metricMixin';
import {
  GOAL_CLICK_MULTI_PAY_PATIENT_INVOICE,
  GOAL_SELECT_CASH_PATIENT_INVOICE,
} from '@/plugins/metric';
import { Bonuses } from '@/mixins/loyaltySystemMixin';
import TheBonus from '@/components/TheBonus.vue';
import BonusInput from './BonusInput.vue';

/**
 * @description Название события закрытия формы.
 * @type {string}
 */
const NAME_EVENT_CANCEL = 'cancel';

/**
 * @description Названия события отправки формы.
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

/**
 * @description Компонент формы оплаты счета.
 * @type {any}
 */
export default {
  components: {
    TheBonus,
    BonusInput,
    ModalDialog,
    PriceInput,
    TheRub,
    TheSelect,
  },
  SHOW_KOP_AUTO,
  computed: {
    /**
     * @description Доступно ли расчёт бонусной картой.
     * @returns {Boolean}
     */
    isAvailableBonusCard() {
      return this.patientLoyaltyCard.isCreated
        && this.patientLoyaltyCard.isTypeBonusCard()
        && this.availableBonuses > 0;
    },
    /**
     * @description Итоговая сумма к оплате.
     * @type {number}
     */
    finalAmount() {
      return this.isMixedPayment ? this.mixedPaymentAmount : this.amountByKop;
    },
    /**
     * @description Деактивировать опцию оплаты авансом.
     * @type {boolean}
     */
    isAdvancePaymentDisabled() {
      return this.amountByKop > this.availableAdvance;
    },
    /**
     * @description Деактивировать кнопку оплаты.
     * @type {boolean}
     */
    isDisabledPaymentButton() {
      if (!this.selectedCashboxId) {
        return true;
      }
      if (this.isMixedPayment) {
        return this.mixedPaymentAmount < this.amountByKop;
      }
      return !this.selectedPaymentType || this.amountByKop === 0;
    },
    /**
     * @description Выбор кассы деактивирован.
     * @type {boolean}
     */
    isCashboxSelectDisabled() {
      return this.cashboxList.length < 2;
    },
    /**
     * @description Выбранный способ оплаты по QR-коду.
     * @type {boolean}
     */
    isSelectedPaymentByQRCode() {
      return this.selectedPaymentType === this.$options.paymentByQRCode;
    },
    /**
     * @description Сумма оплат.
     * @type {number}
     */
    mixedPaymentAmount() {
      return this.cash + this.cashless + this.advance + this.bonuses.toRubles();
    },
  },
  /**
   * @description Тип оплаты наличными.
   * @type {string}
   */
  paymentByCash: 'cash',
  /**
   * @description Тип оплаты по карте.
   * @type {string}
   */
  paymentByCashless: 'cashless',
  /**
   * @description Тип оплаты по бонусной карте.
   * @type {string}
   */
  paymentByBonusCard: 'bonus',
  /**
   * @description Тип оплаты по карте.
   * @type {string}
   */
  paymentByQRCode: 'qr-code',
  /**
   * @description Тип оплаты авансом.
   * @type {string}
   */
  paymentByAdvance: 'advance',
  data() {
    return {
      /**
       * @description Сумма оплаты авансом.
       * @type {number}
       */
      advance: 0,
      /**
       * @description Сумма оплаты бонусами.
       * @type {Bonuses}
       */
      bonuses: new Bonuses(0),
      /**
       * @description Сумма к оплате в копейках.
       * @type {number}
       */
      amountByKop: this.amountToPaid,
      /**
       * @description Сумма оплаты наличными.
       * @type {number}
       */
      cash: 0,
      /**
       * @description Сумма оплаты по карте.
       * @type {number}
       */
      cashless: 0,
      /**
       * @description Смешанный тип оплаты.
       * @type {boolean}
       */
      isMixedPayment: false,
      /**
       * @description Выбранный тип оплаты.
       * @type {string}
       */
      selectedPaymentType: '',
      /**
       * @description Показывать диалог подтверждения оплаты.
       * @type {boolean}
       */
      shownConfirmDialog: false,
    };
  },
  methods: {
    /**
     * @description Отправить событие отмены.
     * @returns {void}
     */
    dispatchCancel() {
      this.$emit(NAME_EVENT_CANCEL);
    },
    /**
     * @description Создать запрос.
     * @returns {PayRequest}
     */
    makeRequest() {
      const paymentTypes = [];
      if (this.isMixedPayment) {
        paymentTypes.push(new PaymentType(this.cash, this.$options.paymentByCash));
        paymentTypes.push(new PaymentType(this.cashless, this.$options.paymentByCashless));
        paymentTypes.push(new PaymentType(this.advance, this.$options.paymentByAdvance));
        paymentTypes.push(new PaymentType(this.bonuses.amount, this.$options.paymentByBonusCard));
      } else if (this.selectedPaymentType === this.$options.paymentByBonusCard) {
        paymentTypes.push(new PaymentType(this.amountByKop / 100, this.selectedPaymentType));
      } else {
        paymentTypes.push(new PaymentType(this.amountByKop, this.selectedPaymentType));
      }
      return new PayRequest(
        this.invoiceId,
        this.selectedCashboxId,
        paymentTypes,
        this.selectedPositions.map(({ position }) => position),
        this.invoiceRevisionNumber,
      );
    },
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmit() {
      const request = this.makeRequest();
      this.$emit(NAME_EVENT_SUBMIT, request);
    },
    /**
     * @description Обработать смену состояния "Смешенная оплата".
     * @returns {void}
     */
    onInputIsMixedPay() {
      this.reachGoalIfNotReach(GOAL_CLICK_MULTI_PAY_PATIENT_INVOICE);
    },
    /**
     * @description Обработать выбор кассы.
     * @param {number} id Идентификатор кассы.
     * @returns {void}
     */
    onSelectCashbox(id) {
      const cashboxId = +id;
      const cashbox = this.cashboxList.find(
        (candidate) => candidate.id === cashboxId,
      );
      if (this.selectedPaymentType === this.$options.paymentByAdvance) {
        this.selectedPaymentType = '';
      }
      this.$emit('select-cashbox', cashbox);
      this.reachGoalIfNotReach(GOAL_SELECT_CASH_PATIENT_INVOICE);
    },
  },
  mixins: [metricMixin],
  name: 'FormInvoicePayment',
  props: {
    /**
     * @description Можно ли полностью расплатиться бонусами
     * @type {Boolean}
     */
    isCanFullyPayByBonuses: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * @description Максимальный процент который можно оплатить бонусной картой
     * @type {Number}
     */
    paymentLimitPercentByBonusCard: {
      type: Number,
      default: 0,
      required: false,
    },
    /**
     * @description Бонусная карта
     * @type {Object|null}
     */
    patientLoyaltyCard: {
      type: Object,
      required: false,
      default: null,
    },
    /**
     * @description Доступный аванс.
     * @type {number}
     */
    availableAdvance: {
      type: Number,
      required: true,
    },
    /**
     * @description Доступные бонусы.
     * @type {number}
     */
    availableBonuses: {
      type: Number,
      required: true,
    },
    /**
     * @description Сумма на оплату.
     * @type {number}
     */
    amountToPaid: {
      type: Number,
      required: true,
    },
    /**
     * @description Список касс.
     */
    cashboxList: {
      required: true,
      type: Array,
    },
    /**
     * @description Долг.
     * @type {number}
     */
    debt: {
      required: true,
      type: Number,
    },
    /**
     * @description Идентификатор счета.
     * @type {number}
     */
    invoiceId: {
      type: Number,
      required: true,
    },
    /**
     * @description Номер ревизии счета.
     */
    invoiceRevisionNumber: {
      type: Number,
      required: true,
    },
    /**
     * @description Ожидание завершения запроса.
     * @type {boolean}
     */
    isAwaitRequest: {
      type: Boolean,
      default: false,
    },
    /**
     * @description Ожидание открытия смены.
     */
    isAwaitShiftOpened: {
      required: true,
      type: Boolean,
    },
    /**
     * @description Включен тип оплаты авансом.
     */
    // paymentByAdvanceEnabled: { required: true, type: Boolean },
    /**
     * @description Идентификатор выбранной кассы.
     */
    selectedCashboxId: {
      default: null,
      type: [Object, Number],
    },
    /**
     * @description Выбранные позиций.
     */
    selectedPositions: {
      type: Array,
      default: () => [],
    },
    /**
     * @description Касса "онлайн-чеки".
     */
    isOnlineCheckCashbox: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    shownConfirmDialog(value) {
      setTimeout(() => {
        this.$emit('shown-confirm-dialog', value);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.form-invoice-payment {
  display: flex;
  flex-direction: column;

  &__buttons {
    &__button-cancel {
      @include buttons.btn-transparent(100%, 56px, 1fr);
    }

    &__button-submit {
      @include buttons.btn-blue(100%, 56px, 1fr);

      &:disabled {
        background-color: var(--unfocus-color);
        border: 1px solid var(--unfocus-color);
        color: white;
      }
    }
  }

  &__qr-code {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__warning {
    color: red;
    font-size: 14px;
  }

  &__confirm-dialog {
    &__buttons {
      display: flex;
      flex-flow: row nowrap;
      margin-top: 18px;
      gap: 8px;
    }

    &__button-cancel {
      @include buttons.btn-transparent(100%, 44px, 16px);
    }

    &__button-submit {
      @include buttons.btn-blue(100%, 44px, 16px);
    }
  }

  &__empty-advance {
    color: var(--warning-color);
  }

  &__head {
    align-items: center;
    column-gap: 15px;
    display: grid;
    grid-template-columns: auto 1fr;
    margin-top: 43px;
    row-gap: 15px;
    padding-bottom: 33px;
    border-bottom: solid 1px #c2cfe0;

    &__amount {
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;

      &.small {
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
      }
    }
  }

  &__payment {
    &-types {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    &-type {
      margin-top: 20px;

      &__title {
        color: var(--reading-color);
        line-height: 24px;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  &__switch::v-deep {
    margin-top: 22px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    span {
      font-size: 18px;
      line-height: 22px;
      color: var(--reading-color);
    }

    .v-input--selection-controls__input:hover .v-input--selection-controls__ripple:before {
      content: none;
    }

    .v-input--selection-controls__ripple {
      display: none;
    }

    .v-input--switch .v-input--switch__track {
      background: white !important;
      border: 1px solid #c2cfe0;
      border-radius: 15px;
      opacity: 1 !important;
    }

    .v-input--switch .v-input--switch__thumb {
      color: #90a0b7;
    }

    .v-input--selection-controls {
      margin: 0 !important;
      padding: 5px !important;
    }
  }

  &__radio {
    & > input {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }

    & > span {
      display: inline-flex;
      align-items: center;
      user-select: none;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      cursor: pointer;
    }

    & > span::before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      flex-grow: 0;
      border: 1px solid #90a0b7;
      border-radius: 50%;
      margin-right: 10px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 50% 50%;
    }

    & > input:not(:disabled):not(:checked) + span:hover::before {
      border: 1px solid #0489e0;
    }

    & > input:checked + span::before {
      border: 1px solid #0489e0;
      background-color: #0489e0;
      box-shadow: inset 0 0 0 6px #fff;
    }
  }

  &__controls {
    margin-top: 61px;
    column-gap: 9px;
    display: grid;
    grid-template-columns: repeat(2, 214px);
    justify-content: flex-end;
  }

  &__inputs {
    margin: 22px 0;
  }

  &__mixed {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 15px;

    &__input {
      border-radius: 4px;
      border: 1px solid #c2cfe0;
      outline: 0;
      padding: 5px 10px;
      height: 36px;

      &:focus {
        border-color: var(--action-color);
      }

      &:hover,
      &:focus {
        appearance: none;
        -moz-appearance: textfield;
      }

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
    }
  }

  &__group {
    display: grid;
    grid-template-columns: 156px 1fr 30px;
    align-items: center;
    column-gap: 8px;
  }
}

@media screen and (max-width: 520px) {
  .form-invoice-payment__controls {
    grid-template-columns: 1fr 1fr;
    justify-content: auto;
  }
}

@media screen and (max-width: 480px) {
  @media screen and (max-width: 480px) {
    .form-invoice-payment {
      &__controls {
        grid-template-columns: 1fr;
        row-gap: 10px;
        margin-top: 20px;
      }

      &__group {
        display: grid;
        grid-template-columns: 1fr 30px;
        align-items: center;
        column-gap: 8px;
        position: relative;
      }

      &__label {
        color: var(--unfocus-color);
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        margin: 0 0 2px 0;
        grid-column: 1/3;
      }

      &__confirm-dialog {
        &__buttons {
          flex-wrap: wrap;
        }
      }
    }
  }
}
</style>
